<template>
  <div class="custom-ui-line-message-wrapper" :class="size">
    <span class="custom-ui-line-message-icon" :class="iconType" v-if="icon">
      <i :class="icon" />
    </span>
    <span class="custom-ui-line-message-text" v-html="formattedMessage" />
  </div>
</template>

<script lang="ts" setup>
  import type { IUILineMessage } from '@/types/Components'
  import { computed } from 'vue'

  const {
    icon = '',
    message = '',
    iconType = 'primary',
    size = 'md',
  } = defineProps<IUILineMessage>()

  const formattedMessage = computed(() => {
    const escaped = message.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    return escaped.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
  })
</script>

<style lang="scss" scoped>
  .custom-ui-line-message-wrapper {
    width: 100%;
    @include flexible;
    font-weight: 400;
    &.xs {
      font-size: 0.625rem;
    }
    &.small {
      font-size: 0.75rem;
    }
    &.medium {
      font-size: 1rem;
    }
    &.large {
      font-size: 1.25rem;
    }
    &.xlarge {
      font-size: 1.5rem;
    }
    &.primary {
      color: $primary-text-color;
    }
    .custom-ui-line-message-icon {
      margin-right: 0.5rem;
      &.primary {
        color: $textColor;
      }
      &.secondary {
        color: $brandColor;
      }
      &.danger {
        color: $danger;
      }
      &.warning {
        color: $warning;
      }
      &.success {
        color: $success;
      }
      &.info {
        color: $info;
      }
    }
    .custom-ui-line-message-text :deep(strong) {
      font-weight: 700;
    }
  }
</style>
